<template>
    <b-table hover
             show-empty
             emptyText="Empty data"
             emptyFilteredText="Empty results"
             :class="['table-bordered']"
             :no-local-sorting="true"
             :no-local-filtering="true"
             :busy="tableBusy"
             :items="items"
             :fields="fields"
             :tbody-tr-class="rowClass"
             primary-key="G"
             @sort-changed="e => $emit('sort', e)">
        <template slot="empty" slot-scope="scope">
            <h4>{{ scope.emptyText }}</h4>
        </template>

        <div if="tableBusy" slot="table-busy" class="text-center text-info my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
        </div>

        <template v-for="name in Object.keys($scopedSlots)" :slot="name" slot-scope="data">
            <slot :name="name" v-bind="data"/>
        </template>
        <template slot="HEAD_status"
                  slot-scope="data">
            <status-select
                v-if="status"
                name="status-select-filter"
                :options="status"
                @statusFiltered="event => $emit('statusFiltered', event)"/>
            <span v-else class="font-weight-bold">{{data.label}}</span>
        </template>

        <template slot="HEAD_dateStatus"
                  slot-scope="data">
            <span>Date created</span>
            <span class="d-block font-weight-normal">Status changed date</span>
        </template>

        <template slot="status" slot-scope="data">
            {{data.item.status | orderStatusFormat}}
        </template>

        <template v-if="data.value[0]" :slot="getImageSlotName" slot-scope="data">
            <img v-if="data.value[0].imageUrl"
                :src="data.value[0] ? data.value[0].imageUrl : ''"
                :alt="`image-${data.item.name}`"
                width="50"
                height="50">
        </template>

        <template slot="currencyCode" slot-scope="data">
            {{'EUR'}}
        </template>
        <template slot="product.currencyCode" slot-scope="data">
            {{'EUR'}}
        </template>
        <date-status-column slot="dateStatus" slot-scope="data" :date="{created: data.item.createdAt, updated: data.item.updatedAt}"></date-status-column>
        <date-column slot="createdAt" slot-scope="data" v-if="data.value" :date="data.value"></date-column>
        <date-column slot="updatedAt" slot-scope="data" v-if="data.value" :date="data.value"></date-column>
        <date-column slot="fulfillmentDate" slot-scope="data" v-if="data.value" :date="data.value"></date-column>
    </b-table>
</template>

<script>
    import StatusSelect from '~cp/UserPanel/Elements/StatusSelect'
    import DateColumn from '~cp/UserPanel/Elements/DateColumn'
    import DateStatusColumn from '~cp/UserPanel/Elements/DateStatusColumn'

    export default {
        name: 'TableElement',
        components: {
            StatusSelect,
            DateColumn,
            DateStatusColumn
        },
        props: {
            tableBusyDisabled: {
                type: Boolean
            },
            items: {
                type: Array,
            },
            fields: {
                type: Array,
                required: true
            },
            status: {
                type: Array,
            },
            spinner: {
                type: Boolean,
                default: true
            },
            rowClass: {
                type: Function
            },
            rowHovered: Function
        },
        mounted() {
        },
        computed: {
            tableBusy() {
                if (!this.tableBusyDisabled) {
                    return this.$store.state.loading
                }
                return false
            },
            getImageSlotName() {
                let imgColumn = this.fields.find(item => item.label === 'Images')
                return imgColumn ? imgColumn.key : 'images'
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/TableElement.vue